/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { FC, useEffect } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import MaterialTable from 'material-table'
import { observer, inject } from 'mobx-react'
import { Settings as SettingsStore } from '../../../stores/settings'
import Spinner from '../../../components/Spinner'
import '../styles.scss'
import Toasts from '../../../components/Dashboard/Toasts'

interface Props extends RouteComponentProps {
  // eslint-disable-next-line react/require-default-props
  settings?: SettingsStore
}

const AdminDNC: FC<Props> = ({ settings }) => {
  useEffect(() => {
    settings?.getDNC()
  }, [])

  return (
    <div className="dnc-selections w-100 p-4">
      <Toasts toasts={settings?.toasts} onClose={(): void => settings?.popFromToasts()} />
      {settings?.dnc?.domains && !settings?.isLoading ? (
        <>
          <div className="description p-4">
            <p>
              We get it, there are some companies you want to work with and some that you don’t.
              Help MaverickApp get to know your preferences even better by telling us who NOT to
              contact on your behalf. Simply click the + sign to add a company’s domain to your do
              not engage list. You can also search through your list to see if they are already
              included.Should you need more help, reach out to an experienced Wingman by clicking on
              SUPPORT in the dropdown menu or emailing the team at
              <a href="maverick@maverickapp.io"> maverick@maverickapp.io</a>
            </p>
          </div>
          <MaterialTable
            data={settings?.dnc?.domains.map(x => ({ domain: x }))}
            columns={[
              {
                title: 'Company Domain (ex: maverickapp.io)',
                field: 'domain',
                validate: rowData =>
                  rowData.domain &&
                  rowData.domain.includes('.') &&
                  !rowData.domain.includes('@') &&
                  !rowData.domain.endsWith('.')
                    ? true
                    : 'Domain must not include @ symbol and must include a value like: maverickapp.io',
              },
            ]}
            options={{
              exportButton: true,
              exportAllData: true,
              loadingType: 'overlay',
              exportFileName: 'Mavericks Do Not Engage - Report',
            }}
            title=""
            localization={{
              header: {
                actions: '',
              },
            }}
            // A return value of type string
            editable={{
              onRowAdd: (newData): Promise<void> =>
                new Promise<void>(resolve => {
                  setTimeout(() => {
                    settings?.handleUpdateDNC({
                      leads: [],
                      domains: [...(settings.dnc?.domains || []), newData.domain],
                    })
                    resolve()
                  }, 1000)
                }),
              onRowDelete: (oldData): Promise<void> =>
                new Promise<void>(resolve => {
                  setTimeout(() => {
                    const localCopy = [...(settings?.dnc?.domains || [])]
                    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                    // @ts-ignore
                    const index = oldData.tableData.id
                    localCopy.splice(index, 1)
                    settings?.handleUpdateDNC({ leads: [], domains: localCopy })
                    resolve()
                  }, 1000)
                }),
            }}
          />
        </>
      ) : (
        <Spinner />
      )}
    </div>
  )
}
export default inject('settings')(observer(AdminDNC))
